module.exports = __webpack_public_path__ + "jtails-build/img/plan-default-Image@2x.65c89789.png";